import '../css/Viewpage.css';
import Popup from './Popup';
import { useEffect, useRef, useState, useLocation } from 'react';
import Filter from './Filter';
import Notification from './Notification';
import { Navigate, useNavigate, Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import ProfileListData from '../model/response/ProfileListData';
import ProfileListRequest from '../model/request/ProfileListRequest';
import user from '../images/user.png';
import logo from '../images/logo.jpeg';
import { Oval } from "react-loader-spinner";
import shortlist from '../images/shortlist.png';
import notShortlist from '../images/nonshortlist.png';
import DocumentRequest from '../model/request/Documentrequest';
import DocumentstatusResponse from '../model/response/DocumentstatusResponse';
import PaiduserDatalist from '../model/response/PaiduserDatalist';
import default_avatar from '../images/default_avatar.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../images/default_avatar.png';
import ProfileDetailsRespone from '../model/response/ProfileDetailsRespone';
import imageCompression from "browser-image-compression";
import Cropper from "react-easy-crop";
import upload from "../images/upload_image.png";
import UpdateDetails from '../model/request/UpdateDetails';
import UpdateDetailsResponse from '../model/response/UpdateDetailsResponse';



function Viewpage() {


   const calledOnce = useRef(false); // ref to track if API has run
   const navigation = useNavigate();
   const [showPopup, setShowPopup] = useState(false);
   const [showMenu, setShowMenu] = useState(false);
   // const [showsubMenu, setShowsubMenu] = useState(false);
   const [isLoading, setIsLoading] = useState(false)
   const [users, setUsers] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const [postsPerPage, setPostperPage] = useState(10);
   const [profile, SetProfile] = useState([]);
   const [activeUser, setActiveUser] = useState([]);
   const [showNotif, setShowNotif] = useState(false);
   const [activeMatchMenu, setActiveMatchMenu] = useState("");
   const [showImageuploadPopup, setshowImageuploadPopup] = useState(false);
   const IMAGE_POPUP_SHOWN_KEY = "imageUploadPopupShown";
   const [hasMore, setHasMore] = useState(true);
   const [filterRequest, setFilterRequest] = useState(null);
   const isFetching = useRef(false);
   const [needImageUpload, setNeedImageUpload] = useState(false);
   const [needLivingPreference, setNeedLivingPreference] = useState(false);
   const [images, setImages] = useState([]);
   const [livingPreference, setLivingPreference] = useState(
      profile.living_Preference_Id ?? ""
   );
   const [isLivingUpdating, setIsLivingUpdating] = useState(false);
   const [cropImage, setCropImage] = useState(null);


   const [crop, setCrop] = useState({
      x: 0,
      y: 0
   });

   const [zoom, setZoom] = useState(1);

   const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

   const [isImageUploading, setIsImageUploading] = useState(false);
   const [themeColor, setThemeColor] = useState(
      localStorage.getItem("themeColor") || "#d83131"
   );
   const [themeColorText, setThemeColorText] = useState(
      localStorage.getItem("themeColourText") || "#d83131"
   );


   const indexOfLastUser = currentPage * postsPerPage;
   const indexOfFirstUser = indexOfLastUser - postsPerPage;
   const currentUsers = users;

   const totalPages = Math.ceil(users.length / postsPerPage);
   const Paginate = (page) => setCurrentPage(page);


   const rawVal = localStorage.getItem('loginVal');
   let loginVal = rawVal ? JSON.parse(rawVal) : null;
   let token = loginVal ? loginVal.token : null;






   const savedImage = localStorage.getItem("image")
   console.log("Viewpage Image:", savedImage);

   const TARGET_WIDTH = 600;
   const TARGET_HEIGHT = 800;

   const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB


   const handleImageChange = (e) => {

      const files = Array.from(e.target.files);

      if (!files.length) {
         return;
      }

      const file = files[0];

      // 5 MB validation
      if (file.size > MAX_IMAGE_SIZE) {

         toast.error(
            `${file.name} size should not exceed 5 MB.`,
            {
               autoClose: 2000
            }
         );

         e.target.value = "";
         return;
      }

      const preview = URL.createObjectURL(file);

      setCropImage({
         file: file,
         preview: preview
      });

      // Same image again select செய்ய
      e.target.value = "";
   };

   const createImage = (url) =>
      new Promise((resolve, reject) => {

         const image = new Image();

         image.onload = () => resolve(image);

         image.onerror = (error) => reject(error);

         image.src = url;
      });

   const getCroppedImg = async (
      imageSrc,
      pixelCrop
   ) => {

      const image = await createImage(imageSrc);

      const canvas = document.createElement("canvas");

      canvas.width = TARGET_WIDTH;
      canvas.height = TARGET_HEIGHT;

      const ctx = canvas.getContext("2d");

      ctx.drawImage(
         image,

         pixelCrop.x,
         pixelCrop.y,
         pixelCrop.width,
         pixelCrop.height,

         0,
         0,
         TARGET_WIDTH,
         TARGET_HEIGHT
      );

      return new Promise((resolve) => {

         canvas.toBlob(
            (blob) => {

               const croppedFile = new File(
                  [blob],
                  `profile-${Date.now()}.jpg`,
                  {
                     type: "image/jpeg"
                  }
               );

               resolve(croppedFile);
            },
            "image/jpeg",
            0.9
         );

      });
   };

   const onCropComplete = (
      croppedArea,
      croppedAreaPixels
   ) => {

      setCroppedAreaPixels(croppedAreaPixels);
   };

   const handleCropSave = async () => {

      try {

         if (!cropImage || !croppedAreaPixels) {
            return;
         }

         // Crop
         const croppedFile =
            await getCroppedImg(
               cropImage.preview,
               croppedAreaPixels
            );

         // Compress
         const compressedFile =
            await imageCompression(
               croppedFile,
               {
                  maxSizeMB: 0.5,
                  maxWidthOrHeight: 1280,
                  useWebWorker: true
               }
            );
         const reader = new FileReader();

         reader.onloadend = () => {
            localStorage.setItem(
               "image",
               reader.result
            );
         };

         reader.readAsDataURL(compressedFile);

         // Add preview
         setImages((prev) => [
            ...prev,
            {
               file: compressedFile,
               preview: URL.createObjectURL(
                  compressedFile
               )
            }
         ]);

         // Remove crop preview
         URL.revokeObjectURL(
            cropImage.preview
         );

         setCropImage(null);

         setCrop({
            x: 0,
            y: 0
         });

         setZoom(1);

      } catch (error) {

         console.error(
            "Crop error:",
            error
         );

         toast.error(
            "Unable to crop image",
            {
               autoClose: 2000
            }
         );
      }
   };

   const handleCropCancel = () => {

      if (cropImage?.preview) {

         URL.revokeObjectURL(
            cropImage.preview
         );
      }

      setCropImage(null);

      setCrop({
         x: 0,
         y: 0
      });

      setZoom(1);
   };
   const removeImage = (index) => {

      setImages((prev) => {

         const removedImage = prev[index];

         if (removedImage?.preview) {

            URL.revokeObjectURL(
               removedImage.preview
            );
         }

         return prev.filter(
            (_, i) => i !== index
         );
      });
   };

   const handleUpload = async () => {

      const rawVal =
         localStorage.getItem("loginVal");

      const loginVal =
         rawVal
            ? JSON.parse(rawVal)
            : null;

      const token =
         loginVal?.token;

      const userId =
         loginVal?.user_Id;


      if (!userId) {

         toast.error(
            "User session expired.",
            {
               autoClose: 2000
            }
         );

         return;
      }


      if (!images.length) {

         toast.error(
            "Please select at least one image.",
            {
               autoClose: 2000
            }
         );

         return;
      }


      try {

         setIsImageUploading(true);

         const formData =
            new FormData();


         // User ID
         formData.append(
            "UserId",
            userId
         );


         // Images
         images.forEach((img) => {

            formData.append(
               "Files",
               img.file
            );
         });


         const response =
            await axios.post(
               ApiConfig.getUrl(
                  "User/FileUpload"
               ),
               formData,
               {
                  headers: {
                     "Content-Type":
                        "multipart/form-data",

                     Authorization:
                        `Bearer ${token}`
                  }
               }
            );


         const api =
            ApiResponse.fromJson(
               response.data
            );


         if (
            api.status &&
            api.statusCode === 200
         ) {

            toast.success(
               api.message ||
               "Images uploaded successfully!",
               {
                  autoClose: 2000
               }
            );


            // Clear selected images
            images.forEach((img) => {

               if (img.preview) {

                  URL.revokeObjectURL(
                     img.preview
                  );
               }
            });

            setImages([]);


            // Popup close
            setshowImageuploadPopup(false);

         } else {

            toast.error(
               api.errorMessage ||
               api.message ||
               "Upload failed!",
               {
                  autoClose: 2000
               }
            );
         }

      } catch (error) {

         console.error(
            "Upload error:",
            error
         );

         toast.error(
            "Upload failed!",
            {
               autoClose: 2000
            }
         );

      } finally {

         setIsImageUploading(false);
      }
   };


   function updateLivingPreference() {

      setIsLivingUpdating(true);

      var request = new UpdateDetails();

      request.user_Id = loginVal.user_Id;

      // Existing profile values
      request.created_For = parseInt(profile.created_ForId);
      request.first_Name = profile.first_Name;

      request.disability = parseInt(profile.disability_id);
      request.body_Type = parseInt(profile.body_Type_id);

      request.height = parseInt(profile.height);
      request.weight = parseInt(profile.weight);

      request.marital_Status = parseInt(
         profile.marital_StatusId
      );

      request.eating_Habit = parseInt(
         profile.eating_HabitId
      );

      request.drinking_Habit = parseInt(
         profile.drinking_HabitId
      );

      request.smoking_Habit = parseInt(
         profile.smoking_HabitId
      );

      // Updated living preference
      request.living_Preference =
         livingPreference === ""
            ? null
            : parseInt(livingPreference);

      request.mother_Tongue = parseInt(
         profile.mother_TongueId
      );

      // Existing DOB
      if (profile.date_Of_Birth) {

         const [date] =
            profile.date_Of_Birth.split(" ");

         const [month, day, year] =
            date.split("/");

         request.date_Of_Birth =
            `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T00:00:00.000Z`;

      } else {

         request.date_Of_Birth = null;

      }

      console.log(
         "Living Preference Update Request:",
         JSON.stringify(request)
      );

      axios.put(
         ApiConfig.getUrl("User/updateBasic"),
         JSON.stringify(request),
         {
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then((response) => {

            console.log(
               "Living Preference Response:",
               response.data
            );

            const api =
               ApiResponse.fromJson(response.data);

            if (
               api.status === true ||
               api.statusCode === 200
            ) {

               if (api.response) {

                  const profileVal =
                     UpdateDetailsResponse.fromJson(
                        api.response
                     );

                  console.log(
                     "Updated Profile:",
                     JSON.stringify(profileVal)
                  );
               }

               toast.success(
                  "Living preference updated successfully.",
                  {
                     autoClose: 2000
                  }
               );

               setNeedLivingPreference(false);

               setshowImageuploadPopup(false);

            } else {

               toast.error(
                  api.message ||
                  api.errorMessage ||
                  "Living preference update failed.",
                  {
                     autoClose: 2000
                  }
               );
            }

            setIsLivingUpdating(false);

         })
         .catch((error) => {

            console.error(
               "Living Preference Update Error:",
               error
            );

            console.error(
               "API Error Response:",
               error?.response?.data
            );

            toast.error(
               error?.response?.data?.message ||
               "Living preference update failed.",
               {
                  autoClose: 2000
               }
            );

            setIsLivingUpdating(false);
         });
   }

   function clickEditprofile() {
      navigation('/Editprofile')
   }
   function clickUpgradeplans() {
      navigation('/Upgrade')
   }
   function clickSettingspage() {
      navigation('/settingspage')
   }

   function clickLogin() {
      logoutAPICall();
   }
   function clickInterestPage() {
      navigation('/Interestpage')
   }
   function clickHomeListPage() {
      navigation('/HomeList')
   }

   function clickSearchPage() {
      navigation('/Searchpage')
   }

   function showToast(message) {
      toast.success(message, {
         position: "top-right",
         autoClose: 2000
      });
   }
   function showToastFailed(message) {
      toast.error(message, {
         position: "top-right",
         autoClose: 2000
      });
   }
   useEffect(() => {
      const token = localStorage.getItem("token");

      if (!token || !loginVal) {
         navigation('/login', { replace: true });
         return;
      }

      if (loginVal.role === 1) {
         showToastFailed("You have no access");
         navigation('/login', { replace: true });
         return;
      }

      if (calledOnce.current) return;
      calledOnce.current = true;
      getProfileAPICall();
      setActiveMatchMenu("your_matches");
      profileListAPICall();
      getmobileStatusAPIcall();

   }, []);

   function profileListAPICall(pageNumber = 1) {
      console.log("pageNumber " + pageNumber)
      if (!loginVal || isFetching.current || (pageNumber > 1 && !hasMore)) return;

      isFetching.current = true;
      setIsLoading(true);
      var request = new ProfileListRequest();
      request.userId = loginVal.user_Id;
      request.ageFrom = loginVal.ageFrom;
      request.ageTo = loginVal.ageTo;
      request.gender = loginVal.gender;
      request.religion = 0;
      request.cast = 0;
      request.heightFrom = 10;
      request.heightTo = 200;
      request.createdFor = "";
      request.maritalStatus = "";
      request.motherTongue = "";
      request.physicalStatus = "";
      request.eatingHabits = "";
      request.smokingHabits = "";
      request.drinkingHabits = "";
      request.familyStatus = "";
      request.familyType = "";
      request.familyValues = "";
      request.occupation = 0;
      request.annualIncomeFrom = 0;
      request.annualIncomeTo = 0;
      request.employmentIn = "";
      request.education = 0;
      request.isShortListed = "";
      request.pageNum = pageNumber;
      request.pageSize = postsPerPage;


      console.log("Response:", JSON.stringify(request));

      axios.post(
         ApiConfig.getUrl("User/getUserByGender"),
         JSON.stringify(request),
         {
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then(response => {
            const api = ApiResponse.fromJson(response.data);
            if (api.status && api.statusCode == 200) {
               const userList = api.response?.userList?.map(item => ProfileListData.fromJson(item)) || [];
               console.log("Page ".concat(pageNumber, " loaded. Items:"), userList.length);

               // Use setUsers(userList) to replace the current view for pagination
               setUsers(userList);

               // Check if we received a full page or at least some data
               setHasMore(userList.length > 0 && userList.length >= postsPerPage);
               setCurrentPage(pageNumber);
            } else {
               // Only clear users if the very first page failed to load
               if (pageNumber === 1) setUsers([]);
               showToast(api.errorMessage);
            }
            isFetching.current = false;
            setIsLoading(false);
         })
         .catch(error => {
            isFetching.current = false;
            setIsLoading(false);

            console.error("Error:", error);

            if (error.response?.status === 401) {
               localStorage.removeItem("token");
               localStorage.removeItem("loginVal");

               navigation("/login");
               return;
            }
         });
   }


   function getProfileAPICall() {
      var obj = { user_Id: loginVal.user_Id, login_user_id: loginVal.user_Id }//user_Id: userId

      console.log("Response:", JSON.stringify(obj));
      axios.post(
         ApiConfig.getUrl("User/getUsersProfile"),
         JSON.stringify(obj),
         {
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then(async response => {
            console.log("Response:", response.data);
            const api = ApiResponse.fromJson(response.data);
            console.log("Response:", api.statusCode);
            // console.log("statusCode:", login.user_Id);
            if (api.statusCode == 200) {
               const profileVal = ProfileDetailsRespone.fromJson(api.response);

               if (profileVal.date_Of_Birth) {

                  const [date] = profileVal.date_Of_Birth.split(" ");

                  const [month, day, year] = date.split("/");

                  const formattedDOB =
                     `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;

                  localStorage.setItem(
                     "user_dob",
                     formattedDOB
                  );

                  console.log("Original DOB:", profileVal.IsPaidForAstrology);
                  console.log("Saved DOB:", formattedDOB);
               }



               if (profileVal.mobile_Number) {
                  try {
                     profileVal.mobile_Number = await ApiConfig.decrypt(profileVal.mobile_Number);
                  } catch (e) { console.error("Mobile decryption failed:", e); }
               }
               if (profileVal.email) {
                  try {
                     profileVal.email = await ApiConfig.decrypt(profileVal.email);
                  } catch (e) { console.error("Email decryption failed:", e); }
               }

               SetProfile(profileVal);
               setLivingPreference(
                  profileVal.living_Preference_Id ??
                  profileVal.living_Preference_Id ??
                  ""
               );

               console.log("FULL PROFILE:", profileVal);
               console.log("GENDER VALUE:", profileVal.gender);
               console.log("LIVING PREFERENCE ID:", profileVal.living_Preference_Id);
               console.log("LIVING PREFERENCE:", profileVal.living_Preference);

               const profileImage =
                  profileVal.profileImage ||
                  profileVal.profilePath;

               const createdForValue =
                  profileVal.created_ForId !== null &&
                     profileVal.created_ForId !== undefined
                     ? String(profileVal.created_ForId).trim()
                     : "";

               const isMale =
                  createdForValue
                     .split(",")
                     .map(x => x.trim())
                     .includes("1");


               const imageMissing =
                  !profileImage ||
                  String(profileImage).trim() === "";

               const livingPreferenceMissing =
                  isMale &&
                  (
                     profileVal.living_Preference_Id == null ||
                     profileVal.living_Preference_Id === "" ||
                     profileVal.living_Preference_Id === 0 ||
                     profileVal.living_Preference_Id === "0"
                  ) &&
                  (
                     profileVal.living_Preference == null ||
                     profileVal.living_Preference === ""
                  );

               console.log("genderValue:", createdForValue);
               console.log("isMale:", isMale);
               console.log("imageMissing:", imageMissing);
               console.log("livingPreferenceMissing:", livingPreferenceMissing);

               setNeedImageUpload(imageMissing);
               setNeedLivingPreference(livingPreferenceMissing);

               // Show popup only once after login
               const popupAlreadyShown =
                  sessionStorage.getItem("imageUploadPopupShown");

               if (
                  (imageMissing || livingPreferenceMissing) &&
                  !popupAlreadyShown
               ) {
                  setshowImageuploadPopup(true);

                  // Mark popup as shown
                  sessionStorage.setItem(
                     "imageUploadPopupShown",
                     "true"
                  );
               }
               // localStorage.setItem("image", profileVal.profileImage)
               // const savedImage = localStorage.getItem("image");
               // console.log("savedImage:", savedImage);
               const isPaidForAstrology = profileVal.isPaidForAstrology;

               localStorage.setItem(
                  "isPaidForAstrology",
                  String(isPaidForAstrology)
               );

               console.log(
                  "Is Paid For Astrology:",
                  isPaidForAstrology
               );

               //showToast(api.message);
            } else {
               showToastFailed(api.errorMessage);
            }

         })
         .catch(error => {

            if (error.response?.status === 401) {
               localStorage.removeItem("token");
               localStorage.removeItem("loginVal");

               navigation("/login");
               return;
            }

            showToastFailed(error);
            console.error("Error:", error);
         });
   }


   // function handlePageChange(page) {
   //    setCurrentPage(page);
   //    profileListAPICall(page);
   //    window.scrollTo(0, 0); // Scroll to top when page changes
   // }

   function handlePageChange(page) {
      if (page < 1) return;

      // Filter applied
      if (filterRequest) {
         FilterAPICall({ ...filterRequest }, page);

         window.scrollTo({
            top: 0,
            behavior: "smooth"
         });
         return;
      }



      switch (activeMatchMenu) {

         case "your_matches":
            profileListAPICall(page);
            break;

         case "you_shortlisted":
            getShortListAPICall(0, page);
            break;

         case "shortlisted_you":
            getShortListAPICall(1, page);
            break;

         case "viewed_you":
            getViewedListAPICall(1, page);
            break;

         case "you_viewed":
            getViewedListAPICall(0, page);
            break;

         default:
            profileListAPICall(page);
      }

      window.scrollTo({
         top: 0,
         behavior: "smooth"
      });
   }
   function logoutAPICall() {

      setIsLoading(true);

      axios.post(
         ApiConfig.getUrl("User/logout"),
         {
            user_Id: loginVal.user_Id
         },
         {
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then((response) => {

            const api = ApiResponse.fromJson(response.data);

            setIsLoading(false);

            if (api.status && api.statusCode === 200) {

               showToast("Logout successful.");


               setTimeout(() => {
                  localStorage.clear();
                  sessionStorage.clear();
                  navigation("/login", { replace: true });
               }, 1000);

            } else {
               showToastFailed(api.errorMessage || "Logout failed");
               localStorage.clear();
               sessionStorage.clear();
               navigation("/login", { replace: true });

            }

         })
         .catch((error) => {

            setIsLoading(false);

            if (error.response?.status === 401) {
               localStorage.clear();
               sessionStorage.clear();
               navigation("/login", { replace: true });
               return;
            }

            console.error(error);
            showToastFailed("Logout failed");
            localStorage.clear();
            sessionStorage.clear();
            navigation("/login", { replace: true });
         });
   }






   function getViewedListAPICall(type, pageNumber = 1) {

      setIsLoading(true);
      setHasMore(false);
      axios.get(
         ApiConfig.getUrl("User/getViewedList"),
         {
            params: {
               userId: loginVal.user_Id, type: type, pageNum: pageNumber,
               pageSize: postsPerPage

            },
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )

         .then(response => {
            const api = ApiResponse.fromJson(response.data);

            if (api.status && api.statusCode == 200) {
               setIsLoading(false);
               const viewedList = api.response?.map(item => ProfileListData.fromJson(item)) || [];
               setCurrentPage(pageNumber);
               setHasMore(viewedList.length === postsPerPage);
               setUsers(viewedList);

            } else {
               showToast(api.errorMessage);
               setIsLoading(false);
               setUsers([]);
            }
         })
         .catch(error => {
            setIsLoading(false);
            setUsers([]);
            showToastFailed(error);
            console.error("Error:", error);
         });
   }

   function saveShortListAPICall(userId, index, type, pageNumber = 1) {

      setIsLoading(true);
      axios.get(
         ApiConfig.getUrl("User/shortList"),
         {
            params: {
               userId: loginVal.user_Id, viewedListId: 0, opponentId: userId, type: type
            },
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )

         .then(response => {
            const api = ApiResponse.fromJson(response.data);
            console.log("Response:", api.statusCode);

            if (api.statusCode == 200) {
               setIsLoading(false);

               setUsers(prevUsers => {
                  const updatedUsers = [...prevUsers];
                  updatedUsers[index] = {
                     ...updatedUsers[index],
                     is_Shortlist: !updatedUsers[index].is_Shortlist,
                  };
                  return updatedUsers;
               });

               if (type === 0) {
                  showToast("Shortlisted Successfully!");
               } else if (type === 1) {
                  showToast("Removed from Shortlist Successfully!");
               }

            } else {
               setIsLoading(false);
               showToastFailed(api.errorMessage);
            }

         })
         .catch(error => {
            setIsLoading(false);
            setUsers([]);
            showToastFailed("ShortList failed!");
            //   showToastFailed(error);
            console.error("Error:", error);
         });
   }

   function getShortListAPICall(type, pageNumber = 1) {

      setIsLoading(true);
      setHasMore(false);
      console.log("Response:", "response.data");
      axios.get(
         ApiConfig.getUrl("User/getShortLists"),
         {
            params: {
               userId: loginVal.user_Id, type: type, pageNum: pageNumber,
               pageSize: postsPerPage
            },
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then(response => {
            const api = ApiResponse.fromJson(response.data);

            if (api.status && api.statusCode == 200) {
               setIsLoading(false);
               const shortList = api.response?.map(item => ProfileListData.fromJson(item)) || [];
               setCurrentPage(pageNumber);
               setHasMore(shortList.length === postsPerPage);
               console.log("Response:", api.shortList);
               setUsers(shortList);
               // showToast(api.message);
            } else {
               showToast(api.errorMessage);
               setIsLoading(false);
               setUsers([]);
            }
         })
         .catch(error => {
            setIsLoading(false);
            setUsers([]);
            showToastFailed(error);
            console.error("Error:", error);
         });
   }


   function getTodayDate() {
      return new Date().toISOString().split('T')[0];
   }

   function getInterestData() {
      const data = localStorage.getItem("interestData");
      return data ? JSON.parse(data) : { date: getTodayDate(), count: 0 };
   }




   function sendInterestAPICall(userId, opponentId, index, type) {

      setIsLoading(true);
      const sentInterestCount = users.filter(
         user => user.is_Interestlist === true
      ).length;

      if (type === 0 && sentInterestCount >= 10) {
         showToastFailed("Daily limit exceeded! You can send only 10 interests per day.");
         return;
      }
      axios.get(
         ApiConfig.getUrl("User/sendPartnerRequest"),
         {
            params: {
               userId: userId, viewedListId: 0, opponentId: opponentId, type: type
            },
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )

         .then(response => {
            const api = ApiResponse.fromJson(response.data);
            console.log("Response:", api.statusCode);
            if (api.statusCode == 200 && api.status === true) {

               setIsLoading(false);

               if (type == 0) {
                  setUsers(prev =>
                     prev.map((user, i) =>
                        i === index ? { ...user, is_Interestlist: true } : user
                     )
                  );
               } else if (type == -1) {
                  setUsers(prev =>
                     prev.map((user, i) =>
                        i === index
                           ? { ...user, is_Interestlist: false, type: -1 }
                           : user
                     )
                  );
               }

               setUsers(prev =>
                  prev.map((user, i) =>
                     i === index ? { ...user, type: type } : user
                  )
               );

               if (type === 0) {
                  showToast("Interest Sent Successfully!");
               } else if (type === -1) {
                  showToast("Interest Removed Successfully!");
               } else if (type === 1) {
                  showToast("Interest Accepted Successfully!");
               } else if (type === 2) {
                  showToast("Interest Declined Successfully!");
               }
            }

         })
         .catch(error => {
            setIsLoading(false);
            showToastFailed("Interest Sent fail!");
         });
   }

   function FilterAPICall(request, pageNumber = 1) {
      setFilterRequest(request);
      console.log("pageNumber " + pageNumber);

      if (!loginVal || isFetching.current || (pageNumber > 1 && !hasMore)) return;

      isFetching.current = true;

      request.pageNum = pageNumber;
      request.pageSize = postsPerPage;

      setShowPopup(false);
      setIsLoading(true);

      console.log("Response:", JSON.stringify(request));

      axios.post(
         ApiConfig.getUrl("User/filterByGender"),
         JSON.stringify(request),
         {
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then(response => {
            const api = ApiResponse.fromJson(response.data);

            if (api.statusCode == 200) {

               const userList =
                  api.response?.userList?.map(item =>
                     ProfileListData.fromJson(item)
                  ) || [];

               console.log(
                  "Filter Page:",
                  pageNumber,
                  "Users:",
                  userList.length
               );

               setUsers(userList);


               setHasMore(userList.length === postsPerPage);

               setCurrentPage(pageNumber);

            } else {


               if (pageNumber === 1) {
                  setUsers([]);
                  setHasMore(false);
               }

               showToast(api.errorMessage);
            }

            isFetching.current = false;
            setIsLoading(false);
         })
         .catch(error => {

            isFetching.current = false;
            setIsLoading(false);

            console.error("Filter API Error:", error);

            if (pageNumber === 1) {
               setUsers([]);
               setHasMore(false);
            }
         });
   }


   // console.log(loginVal.type);



   function clicktoCustomerdetailsscreen(userId, is_Paid, isPaid) {
      navigation('/Customerdetails', { state: { userId: userId, is_Paid: is_Paid, isPaid: isPaid } })
   }



   function getmobileStatusAPIcall() {
      setIsLoading(true);

      console.log("Response:", "response.data");
      axios.get(
         ApiConfig.getUrl("User/mobileStatus"),
         {

            params: { getProfile: loginVal.user_Id },

            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then(response => {
            const api = ApiResponse.fromJson(response.data);
            console.log("Response:", api.statusCode);

            if (api.statusCode === 200) {

               if (api.response.mobileNumber_Status === false) {
                  // setShowVerifyPopup(true);
               } else {
                  // setShowVerifyPopup(false);
               }
               setIsLoading(false);
            }



            // } else {
            //   showToastFailed(api.errorMessage);
            // }

         })
         .catch(error => {
            setIsLoading(false);
            // showToastFailed(error);
            // console.error("Error:", error);
         });
   }




   function mobileNumberotpAPICall() {
      axios.post(
         ApiConfig.getUrl("User/mobileStatusVerify"),
         JSON.stringify({
            status: loginVal.status,
            otp: loginVal.otp,
            message: loginVal.message,
         }),
         {
            params: { userId: loginVal.user_Id },
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )
         .then(response => {
            const api = ApiResponse.fromJson(response.data);

            if (api.statusCode === 200) {
               setIsLoading(false);
               showToast("OTP Sent Successfully!");


               navigation('/Numberotp');
            } else {
               setIsLoading(false);
            }
         })
         .catch(error => {
            setIsLoading(false);
            showToastFailed("Failed to send OTP!");
         });
   }



   function sendChatRequestAPIcall(userId, opponentId, index, requestType) {
      setIsLoading(true);
      axios.get(
         ApiConfig.getUrl("User/sendChatRequest"),
         {
            params: {
               user_Id: userId, opponent_Id: opponentId, requestType: requestType, LoggedInUser_Id: loginVal.user_Id
            },
            headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`
            }
         }
      )

         .then(response => {
            const api = ApiResponse.fromJson(response.data);
            console.log("Response:", api.statusCode);
            if (api.statusCode == 200 && api.status == true) {


               setIsLoading(false);
               if (requestType == 0) {
                  setUsers(prev =>
                     prev.map((user, i) =>
                        i === index ? { ...user, is_ChatRequest: true } : user
                     )
                  );
               }
               else if (requestType == -1) {
                  setUsers(prev =>
                     prev.map((user, i) =>
                        i === index ? { ...user, is_ChatRequest: null, requestType: null } : user
                     )
                  );

               }
               setUsers(prev =>
                  prev.map((user, i) =>
                     i === index ? { ...user, requestType: requestType } : user
                  )
               );

               // showToast("Chat Request Sent Successfully!");


            } else {
               showToastFailed(api.errorMessage);

               setIsLoading(false);
            }

         })
         .catch(error => {
            setIsLoading(false);
            showToastFailed("Chat Request Sent fail!");
         });
   }

   const disableRightClick = (e) => {
      if (ApiConfig.ENV == "PRD") {
         e.preventDefault();
      }
   };


   return (
      <>

         <div>
            <ToastContainer />

            <Popup
               show={showImageuploadPopup}
               onClose={() => {

                  if (!isImageUploading) {
                     setshowImageuploadPopup(false);
                  }

               }}
            >

               {/* =========================
        CROP POPUP
    ========================== */}

               {cropImage && (

                  <div
                     style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,

                        background:
                           "rgba(0,0,0,0.75)",

                        zIndex: 99999,

                        display: "flex",

                        justifyContent:
                           "center",

                        alignItems:
                           "center",

                        padding: "20px"
                     }}
                  >

                     <div
                        style={{
                           width: "100%",
                           maxWidth: "550px",

                           background: "#fff",

                           borderRadius: "15px",

                           padding: "20px"
                        }}
                     >

                        <h5
                           className="text-center mb-3"
                        >
                           Adjust Your Photo
                        </h5>


                        {/* Crop Area */}

                        <div
                           style={{
                              position: "relative",

                              width: "100%",

                              height: "400px",

                              background: "#333",

                              borderRadius: "10px",

                              overflow: "hidden"
                           }}
                        >

                           <Cropper
                              image={cropImage.preview}

                              crop={crop}

                              zoom={zoom}

                              aspect={3 / 4}

                              onCropChange={
                                 setCrop
                              }

                              onZoomChange={
                                 setZoom
                              }

                              onCropComplete={
                                 onCropComplete
                              }
                           />

                        </div>


                        {/* Zoom */}

                        <div className="mt-3">

                           <label
                              className="form-label"
                           >
                              Zoom:{" "}
                              {zoom.toFixed(1)}x
                           </label>

                           <input
                              type="range"

                              min="1"

                              max="3"

                              step="0.1"

                              value={zoom}

                              onChange={(e) =>
                                 setZoom(
                                    Number(
                                       e.target.value
                                    )
                                 )
                              }

                              className="form-range"
                           />

                        </div>


                        {/* Crop Buttons */}

                        <div
                           className="d-flex gap-2 mt-3"
                        >

                           <button
                              type="button"

                              className="btn btn-secondary w-50"

                              onClick={
                                 handleCropCancel
                              }
                           >
                              Cancel
                           </button>


                           <button
                              type="button"

                              className="btn btn-success w-50"

                              onClick={
                                 handleCropSave
                              }
                           >
                              Crop & Add
                           </button>

                        </div>

                     </div>

                  </div>

               )}


               {/* =========================
        MAIN POPUP
    ========================== */}

               <div
                  style={{
                     padding: "25px"
                  }}
               >

                  {/* =========================
            IMAGE UPLOAD SECTION
        ========================== */}

                  {needImageUpload && (

                     <div>

                        <h5
                           className="text-center fw-bold mb-2"
                        >
                           Upload Your Profile Image
                        </h5>


                        <p
                           className="text-center text-muted mb-3"
                        >
                           Please upload your profile
                           image to continue.
                        </p>


                        {/* Upload Box */}

                        <label
                           htmlFor="popupFileUpload"

                           className="d-flex flex-column justify-content-center align-items-center"

                           style={{
                              border:
                                 "2px dashed #ff8c00",

                              borderRadius:
                                 "12px",

                              padding:
                                 "25px",

                              cursor:
                                 "pointer",

                              backgroundColor:
                                 "#fff7f0",

                              minHeight:
                                 "150px"
                           }}
                        >

                           {images.length === 0 ? (

                              <>
                                 <img
                                    src={upload}
                                    alt="upload"

                                    style={{
                                       width: "65px",

                                       marginBottom:
                                          "10px",

                                       opacity: 0.8
                                    }}
                                 />

                                 <p
                                    className="mb-1 fw-semibold text-dark"
                                 >
                                    Click and Select
                                    Image Here
                                 </p>

                                 <small
                                    className="text-muted"
                                 >
                                    JPG / PNG up to
                                    5 MB
                                 </small>
                              </>

                           ) : (

                              <p
                                 className="mb-0 fw-semibold text-dark"
                              >
                                 Click to Add More
                                 Images
                              </p>

                           )}

                        </label>


                        {/* Hidden File Input */}

                        <input
                           id="popupFileUpload"

                           type="file"

                           accept="image/*"

                           multiple

                           onChange={
                              handleImageChange
                           }

                           style={{
                              display: "none"
                           }}
                        />


                        {/* =========================
                    SELECTED IMAGE PREVIEW
                ========================== */}

                        {images.length > 0 && (

                           <div
                              className="d-flex flex-wrap justify-content-center gap-3 mt-4"
                           >

                              {images.map(
                                 (img, index) => (

                                    <div
                                       key={index}

                                       className="position-relative"

                                       style={{
                                          width:
                                             "100px",

                                          height:
                                             "130px"
                                       }}
                                    >

                                       <img
                                          src={
                                             img.preview
                                          }

                                          alt="preview"

                                          className="img-thumbnail w-100 h-100"

                                          style={{
                                             objectFit:
                                                "cover",

                                             borderRadius:
                                                "10px"
                                          }}
                                       />


                                       {/* Remove */}

                                       <button
                                          type="button"

                                          onClick={() =>
                                             removeImage(
                                                index
                                             )
                                          }

                                          className="btn btn-danger btn-sm position-absolute top-0 end-0 translate-middle rounded-circle d-flex align-items-center justify-content-center"

                                          style={{
                                             width:
                                                "25px",

                                             height:
                                                "25px",

                                             padding:
                                                0
                                          }}
                                       >
                                          ×
                                       </button>

                                    </div>

                                 )
                              )}

                           </div>

                        )}


                        {/* =========================
                    UPLOAD BUTTON
                ========================== */}

                        <button
                           type="button"

                           className="send-button w-100 mt-4"

                           onClick={
                              handleUpload
                           }

                           disabled={
                              images.length === 0 ||
                              isImageUploading
                           }

                           style={{
                              opacity:
                                 images.length === 0 ||
                                    isImageUploading
                                    ? 0.6
                                    : 1,

                              cursor:
                                 images.length === 0 ||
                                    isImageUploading
                                    ? "not-allowed"
                                    : "pointer"
                           }}
                        >

                           {isImageUploading ? (

                              <span
                                 className="d-flex justify-content-center align-items-center gap-2"
                              >

                                 <Oval
                                    height="20"
                                    width="20"
                                    color="#ffffff"
                                    secondaryColor="#cccccc"
                                    strokeWidth="4"
                                    visible={true}
                                 />

                                 Uploading...

                              </span>

                           ) : (

                              "Upload Image"

                           )}

                        </button>

                     </div>

                  )}


                  {/* =========================
            LIVING PREFERENCE
        ========================== */}

                  {/* =========================
    LIVING PREFERENCE
========================= */}

                  {needLivingPreference && (

                     <div
                        style={{
                           marginTop: needImageUpload ? "30px" : "0",
                           borderTop: needImageUpload
                              ? "1px solid #ddd"
                              : "none",
                           paddingTop: needImageUpload
                              ? "25px"
                              : "0"
                        }}
                     >

                        <h5 className="text-center fw-bold">
                           Update Your Living Preference
                        </h5>

                        <p className="text-center text-muted">
                           Please update your living preference.
                        </p>

                        {/* =========================
          LIVING PREFERENCE DROPDOWN
      ========================== */}

                        <div className="mt-3">

                           <label className="form-label fw-semibold">
                              Living Preference
                           </label>

                           <select
                              className="form-select"
                              value={livingPreference}
                              onChange={(e) =>
                                 setLivingPreference(e.target.value)
                              }
                              disabled={isLivingUpdating}
                           >
                              <option value="">
                                 Select Living Preference
                              </option>

                              <option value="1">
                                 Traditional / Groom's Home
                              </option>

                              <option value="2">
                                 Willing to live with Bride's Family
                              </option>

                              <option value="3">
                                 Independent
                              </option>

                              <option value="4">
                                 Flexible
                              </option>

                           </select>

                        </div>


                        {/* =========================
          SAVE BUTTON
      ========================== */}

                        <button
                           type="button"
                           className="send-button w-100 mt-3"
                           onClick={updateLivingPreference}
                           disabled={
                              !livingPreference ||
                              isLivingUpdating
                           }
                           style={{
                              opacity:
                                 !livingPreference ||
                                    isLivingUpdating
                                    ? 0.6
                                    : 1,

                              cursor:
                                 !livingPreference ||
                                    isLivingUpdating
                                    ? "not-allowed"
                                    : "pointer"
                           }}
                        >

                           {isLivingUpdating ? (

                              <span
                                 className="d-flex justify-content-center align-items-center gap-2"
                              >

                                 <Oval
                                    height="20"
                                    width="20"
                                    color="#ffffff"
                                    secondaryColor="#cccccc"
                                    strokeWidth="4"
                                    visible={true}
                                 />

                                 Saving...

                              </span>

                           ) : (

                              "Save"

                           )}

                        </button>

                     </div>

                  )}

               </div>

            </Popup>
            <div className='fullview' onContextMenu={disableRightClick}>
               {isLoading && (
                  <div className="loader-overlay">
                     <Oval
                        height={60}
                        width={60}
                        color="orange"
                        secondaryColor="#cccccc"
                        strokeWidth={4}
                        visible={true}
                     />
                  </div>
               )}

               <div className="top-bar ">
                  <div className='container'>
                     <ul className="d-flex align-items-center mb-0 position-relative">
                        {/* <li>Home</li>
               <li>Matches</li> */}
                        <img src={logo} alt='logo' style={{ width: '60px' }} />
                        <li className="m-2 p-1" onClick={clickHomeListPage}>
                           <i className="bi bi-house d-inline m-2"></i>
                           <span className="d-none d-sm-inline text-decoration-none text-dark">Home</span>
                        </li>

                        <li onClick={clickInterestPage} className='m-2 p-1'><i className="bi bi-heart d-inline m-2"></i>
                           <span className="d-none d-sm-inline text-decoration-none text-dark">Interests</span></li>
                        <li onClick={clickSearchPage} className='m-2 p-1'><i className="bi bi-search d-inline m-2"></i>
                           <span className="d-none d-sm-inline text-decoration-none text-dark">Search</span></li>



                        <li className='m-2 p-1' onClick={() => setShowNotif(true)} >
                           <i className="bi bi-bell d-inline m-2"></i>
                           <span className="d-none d-sm-inline  text-decoration-none text-dark">Notification</span></li>
                        <Notification
                           show={showNotif}
                           onClose={() => setShowNotif(false)}
                        />


                        {/* <button className='top-button'>Switch account</button> */}
                        <div style={{ position: "relative", display: "inline-block" }}>



                           <img style={{ width: "50px", height: "50px", borderRadius: "50% " }}

                              src={savedImage || default_avatar}
                              onClick={() => setShowMenu(!showMenu)}
                           />
                           {showMenu && (
                              <div className="dropdown-menu show" style={{ position: "absolute", right: "5px" }}>
                                 <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickEditprofile}>Edit Profile</div>
                                 {/* <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickUpgradeplans}>Upgrade Plan</div> */}
                                 <div className="dropdown-item " style={{ cursor: "pointer" }} onClick={clickSettingspage} >Settings</div>
                                 {/* {showsubMenu && (
                                    <div className="dropdown-item" style={{ cursor: "pointer", textAlign: "center", backgroundColor: "darkorange", color: "white" }}>Block List</div>
                                 )} */}

                                 <div className="dropdown-item" style={{ cursor: "pointer" }} onClick={clickLogin}>Logout</div>
                              </div>
                           )}
                        </div>
                        {/* <button className='top-button'>Settings</button> */}
                     </ul>
                  </div>

               </div>
               <div className='container-md' onClick={() => setShowMenu(false)} >
                  <div className='row mt-5 pt-5 align-items-start gl-0 gx-0 '>
                     <div className="d-lg-none p-2 text-end align-items-end" >
                        <button
                           className="btn btn-outline-secondary"
                           type="button"
                           data-bs-toggle="collapse"
                           data-bs-target="#mobileMenu"
                        >
                           ☰
                        </button>
                     </div>
                     <div
                        id="mobileMenu"
                        className="collapse d-lg-block col-lg-3 col-sm-12 border_menu sticky-sidebar"
                     >
                        <b className="d-none d-lg-block ms-2 mt-2">All Matches</b>

                        <div className={`topic_menu ${activeMatchMenu === "your_matches" ? "active-menu" : ""}`}
                           onClick={() => {
                              setFilterRequest(null);
                              setActiveMatchMenu("your_matches");
                              profileListAPICall(1);
                           }}>
                           <label><b>Your Matches</b></label>
                           <label className="d-none d-lg-block">
                              View all the profiles that match your Preferences
                           </label>
                        </div>

                        <hr />

                        <b className="d-none d-lg-block ms-2 mt-2">Based on Activity</b>

                        <div className={`topic_menu ${activeMatchMenu === "you_shortlisted" ? "active-menu" : ""}`}
                           onClick={() => {
                              setFilterRequest(null);
                              setActiveMatchMenu("you_shortlisted");
                              getShortListAPICall(0, 1);
                           }}>
                           <label><b>Shortlisted by you</b></label>
                           <label>
                              Matches you have Shortlisted
                           </label>
                        </div>

                        <hr />

                        <div className={`topic_menu ${activeMatchMenu === "viewed_you" ? "active-menu" : ""}`}
                           onClick={() => {
                              setFilterRequest(null);
                              setActiveMatchMenu("viewed_you");
                              getViewedListAPICall(1, 1);
                           }}>
                           <label><b>Viewed you</b></label>
                           <label className="d-none d-lg-block">
                              Matches who have viewed your profile
                           </label>
                        </div>

                        <hr />

                        <div className={`topic_menu ${activeMatchMenu === "shortlisted_you" ? "active-menu" : ""}`}
                           onClick={() => {
                              setFilterRequest(null);
                              setActiveMatchMenu("shortlisted_you");
                              getShortListAPICall(1, 1);
                           }}>
                           <label><b>Shortlisted you</b></label>
                           <label className="d-none d-lg-block">
                              Matches who have Shortlisted your profile
                           </label>
                        </div>

                        <hr />

                        <div className={`topic_menu ${activeMatchMenu === "you_viewed" ? "active-menu" : ""}`}
                           onClick={() => {
                              setFilterRequest(null);
                              setActiveMatchMenu("you_viewed");
                              getViewedListAPICall(0, 1);
                           }}>
                           <label><b>Viewed by you</b></label>
                           <label className="d-none d-lg-block">
                              Matches you have viewed
                           </label>
                        </div>
                     </div>

                     <div className='col-lg-9 col-sm-12'>
                        {/* <h3>
                        Matches based on your <span>Preferences</span>
                     </h3> */}

                        <div className='button-end ms-3' style={{ position: "sticky", top: "0" }}>
                           <button className='button-head'
                              onClick={() => setShowPopup(true)}>Filter</button>

                        </div>
                        {showPopup && (
                           <div style={{
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100vw',
                              height: '100vh',
                              backgroundColor: 'rgba(0,0,0,0.5)',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              zIndex: 2000
                           }}>
                              <div style={{
                                 background: '#fff',
                                 borderRadius: '10px',
                                 width: '90%',
                                 maxWidth: '1000px',
                                 maxHeight: '85vh',
                                 overflowY: 'auto',
                                 padding: '20px',
                                 boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                              }}>
                                 <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                                    <h2>Filter</h2>
                                    <button onClick={() => setShowPopup(false)} style={{ cursor: 'pointer', border: "none" }}>X</button>
                                 </div>

                                 <Filter apply={FilterAPICall} />
                              </div>
                           </div>
                        )}

                        <div className='mt-5 ms-lg-2'>

                           {users.length > 0 ? (
                              users.map((item, index) => (
                                 <div
                                    key={item.userId}
                                    className="client"
                                    onClick={() => clicktoCustomerdetailsscreen(item.userId)}
                                    style={{
                                       background: item.themeColour || localStorage.getItem("themeColor") || "#ffffff",
                                       color: item.themeColourText || localStorage.getItem("themeColourText") || "#0f0b0b"
                                    }}
                                 >

                                    <div style={{ position: "relative" }}>

                                       {(item.isPaid === true || item.is_Paid === true) && (
                                          <div
                                             style={{
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                zIndex: 10,
                                                background: "#FFD700",
                                                color: "#000",
                                                padding: "4px 8px",
                                                borderRadius: "15px",
                                                fontSize: "11px",
                                                fontWeight: "bold",
                                                boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                                             }}
                                          >
                                             ⭐ {item.lookUpId || "Premium"}
                                          </div>
                                       )}

                                       <img
                                          className="list-a-img"
                                          src={
                                             item.profilePath == null || item.profilePath === ""
                                                ? default_avatar
                                                : item.profilePath
                                          }
                                          style={{
                                             height: "80%",
                                             objectFit: "fill",
                                             objectPosition: "center",
                                             filter: item.isBlurred ? "blur(5px)" : "none",
                                             transition: "filter 0.3s ease"
                                          }}
                                          alt="Profile"
                                       />
                                    </div>
                                    <div className='col details'>

                                       <div >
                                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                             <label
                                                className="name fw-bold text-wrap"
                                                style={{
                                                   background: item.themeColourText || "#131111",
                                                   WebkitBackgroundClip: "text",
                                                   WebkitTextFillColor: "transparent",
                                                   backgroundClip: "text"
                                                }}
                                             >
                                                {item.name}
                                             </label>


                                             <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>

                                                <div
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      saveShortListAPICall(item.userId, index, item.is_Shortlist == true ? 1 : 0);
                                                   }}>

                                                   <img className='shortlist-logo' src={item.is_Shortlist == true ? shortlist : notShortlist} alt='logo' />

                                                </div>
                                             </div>
                                          </div>
                                          <div style={{ paddingBottom: "10px" }}>
                                             <label
                                                className="normal"
                                                style={{
                                                   background: item.themeColourNumber || "#333333",
                                                   WebkitBackgroundClip: "text",
                                                   WebkitTextFillColor: "transparent",
                                                   backgroundClip: "text",
                                                   fontWeight: "bold"
                                                }}
                                             >
                                                IMIT{item.userNum}
                                             </label>
                                          </div>


                                          <ul style={{
                                             display: "flex",
                                             flexWrap: "wrap",
                                             listStyleType: "disc",
                                             paddingLeft: "0px",
                                             margin: "0", textDecoration: "none",
                                             listStyleType: "none", color: item.themeColourText

                                          }}>

                                             <li style={{
                                                paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0,
                                                listStyleType: 'none',
                                                textDecoration: 'none',
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: item.themeColourText || "#333333",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text"
                                             }} className='normal-text'>
                                                <span
                                                   style={{
                                                      paddingRight: 10,
                                                      fontSize: '1.2rem',
                                                      marginBottom: '4px',
                                                      textDecoration: 'none',
                                                      color: 'rgb(255, 123, 0)',
                                                      WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                   }}
                                                >
                                                   •
                                                </span>{item.age} yrs
                                             </li>

                                             <li style={{
                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text"
                                             }} className='normal-text'>
                                                <span style={{
                                                   paddingRight: 10,
                                                   fontSize: '1.2rem',
                                                   marginBottom: '4px',
                                                   textDecoration: 'none',
                                                   color: 'rgb(255, 123, 0)',
                                                   WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                }}>•</span> {item.height} CM
                                             </li>
                                             <li style={{
                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text"
                                             }} className='normal-text'>
                                                <span style={{
                                                   paddingRight: 10,
                                                   fontSize: '1.2rem',
                                                   marginBottom: '4px',
                                                   textDecoration: 'none',
                                                   color: 'rgb(255, 123, 0)',
                                                   WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                }}>•</span> {item.caste}
                                             </li>


                                          </ul>

                                          <ul style={{
                                             display: "flex",
                                             flexWrap: "wrap",
                                             listStyleType: "disc",
                                             paddingLeft: "0px",
                                             margin: "0",
                                          }}>


                                             <li style={{
                                                paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0, background: item.themeColourText || "#333333",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text"
                                             }} className='normal-text'>
                                                <span style={{
                                                   paddingRight: 10,
                                                   fontSize: '1.2rem',
                                                   marginBottom: '4px',
                                                   textDecoration: 'none',
                                                   color: 'rgb(255, 123, 0)',
                                                   WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                }}>•</span> {item.religion}
                                             </li>
                                             <li style={{
                                                paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0, background: item.themeColourText || "#333333",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text"
                                             }} className='normal-text'>
                                                <span style={{
                                                   paddingRight: 10,
                                                   fontSize: '1.2rem',
                                                   marginBottom: '4px',
                                                   textDecoration: 'none',
                                                   color: 'rgb(255, 123, 0)',
                                                   WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                }}>•</span> {item.qualification}{item.educationCategory}
                                             </li>

                                             <li style={{
                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text"
                                             }} className='normal-text'>
                                                <span style={{
                                                   paddingRight: 10,
                                                   fontSize: '1.2rem',
                                                   marginBottom: '4px',
                                                   textDecoration: 'none',
                                                   color: 'rgb(255, 123, 0)',
                                                   WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                }}>•</span> {item.occupation}
                                             </li>

                                          </ul>

                                          <ul style={{
                                             display: "flex",
                                             flexWrap: "wrap",
                                             listStyleType: "disc",
                                             paddingLeft: "0px",
                                             listStylePosition: "inside",
                                             margin: "0",
                                          }}>


                                             <li style={{
                                                paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0, background: item.themeColourText || "#333333",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text"
                                             }} className='normal-text'>
                                                <span style={{
                                                   paddingRight: 10,
                                                   fontSize: '1.2rem',
                                                   marginBottom: '4px',
                                                   textDecoration: 'none',
                                                   color: 'rgb(255, 123, 0)',
                                                   WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                }}>•</span> {item.city}
                                             </li>

                                             <li style={{
                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text"
                                             }} className='normal-text'>
                                                <span style={{
                                                   paddingRight: 10,
                                                   fontSize: '1.2rem',
                                                   marginBottom: '4px',
                                                   textDecoration: 'none',
                                                   color: 'rgb(255, 123, 0)',
                                                   WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                }}>•</span> {item.state}
                                             </li>
                                             <li style={{
                                                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, background: item.themeColourText || "#333333",
                                                WebkitBackgroundClip: "text",
                                                WebkitTextFillColor: "transparent",
                                                backgroundClip: "text"
                                             }} className='normal-text'>
                                                <span style={{
                                                   paddingRight: 10,
                                                   fontSize: '1.2rem',
                                                   marginBottom: '4px',
                                                   textDecoration: 'none',
                                                   color: 'rgb(255, 123, 0)',
                                                   WebkitTextFillColor: 'rgb(255, 123, 0)'
                                                }}>•</span> {item.country}.
                                             </li>
                                          </ul>
                                       </div>


                                       <div className=' mt-3'>

                                          {item.type == 0 && item.is_Interestlist == true && (
                                             <button
                                                className='send-button'
                                                onClick={(e) => {
                                                   e.stopPropagation();
                                                   sendInterestAPICall(loginVal.user_Id, item.userId, index, -1);
                                                }}>
                                                Remove Interest
                                             </button>
                                          )}
                                          {item.type == 1 && item.is_Interestlist == true && (
                                             <label style={{ color: "green" }}>
                                                <b>Your request is accepted</b>
                                             </label>
                                          )}

                                          {item.type == 2 && item.is_Interestlist == true && (
                                             <label style={{ color: "red" }}>
                                                <b>Your request is declined</b>
                                             </label>
                                          )}


                                          {(item.type == null || item.type == -1) && (
                                             <button
                                                className='send-button'
                                                onClick={(e) => {
                                                   e.stopPropagation();
                                                   sendInterestAPICall(loginVal.user_Id, item.userId, index, 0);
                                                }}
                                             >
                                                Send Interest
                                             </button>
                                          )}


                                          {item.type == 0 && item.is_Interestlist == false && (

                                             <>
                                                <button
                                                   className='send-button'
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      sendInterestAPICall(item.userId, loginVal.user_Id, index, 1);
                                                   }}
                                                >
                                                   Accept Interest
                                                </button>

                                                <button
                                                   className='send-button'
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      sendInterestAPICall(item.userId, loginVal.user_Id, index, 2);
                                                   }}
                                                >
                                                   Decline
                                                </button>

                                             </>
                                          )}

                                          {item.type == 1 && item.is_Interestlist == false && (

                                             <>
                                                <label> Accepted  </label>

                                                <button
                                                   className='send-button'
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      sendInterestAPICall(item.userId, loginVal.user_Id, index, 2);
                                                   }}
                                                >
                                                   Decline
                                                </button>

                                             </>
                                          )}

                                          {item.type == 2 && item.is_Interestlist == false && (

                                             <>

                                                <button
                                                   className='send-button'
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      sendInterestAPICall(item.userId, loginVal.user_Id, index, 1);
                                                   }}
                                                >
                                                   Accept Interest
                                                </button>
                                                <label>
                                                   Declined
                                                </label>
                                             </>
                                          )}
                                       </div>
                                       <div className='me-3 mt-2 '>


                                          {(item.type == 1) && (item.requestType == 0) && (item.is_ChatRequest == true) && (
                                             <button
                                                className='send-button' style={{ fontSize: "12px" }}
                                                onClick={(e) => {
                                                   e.stopPropagation();
                                                   sendChatRequestAPIcall(loginVal.user_Id, item.userId, index, -1);
                                                }}>
                                                Remove Chat Interest
                                             </button>
                                          )}
                                          {/* {item.requestType == 1 && item.is_Interestlist == true && (
                                             <label>
                                                <b>Your request is accepted</b>
                                             </label>
                                          )}

                                          {item.requestType == 2 && item.is_Interestlist == true && (
                                             <label>
                                                <b>Your request is declined</b>
                                             </label>
                                          )} */}


                                          {(item.type == 1) && (item.requestType == null || item.requestType == -1) && (
                                             <button
                                                className='send-button' style={{ fontSize: "12px" }}
                                                onClick={(e) => {
                                                   e.stopPropagation();
                                                   sendChatRequestAPIcall(loginVal.user_Id, item.userId, index, 0);
                                                }}
                                             >
                                                Send Chat Interest
                                             </button>
                                          )}


                                          {(item.type == 1) && (item.requestType == 0) && (item.is_ChatRequest == false) && (

                                             <>
                                                <button
                                                   className='send-button'
                                                   style={{ fontSize: "13px" }}
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      sendChatRequestAPIcall(item.userId, loginVal.user_Id, index, 1);
                                                   }}
                                                >
                                                   Accept Chat Interest
                                                </button>

                                                <button
                                                   className='send-button'
                                                   style={{ fontSize: "13px" }}
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      sendChatRequestAPIcall(item.userId, loginVal.user_Id, index, 2);
                                                   }}
                                                >
                                                   Decline Chat Interest
                                                </button>

                                             </>
                                          )}


                                          {(item.requestType == 1) && (
                                             <div
                                                title="Chat"
                                                className='ChatMessage'
                                                //  style={{ cursor:'pointer'}}

                                                onClick={(e) => {
                                                   e.stopPropagation();
                                                   navigation('/ChatInitiate', { state: { opponentId: item.userId, opponentName: item.name } })
                                                }}
                                             >
                                                <i className="bi bi-chat-dots fs-3" style={{ color: "darkorange" }}></i>
                                             </div>
                                          )}

                                          {/* {item.type == 1 && item.is_Interestlist == false && (

                                             <>
                                                <label> Accepted  </label>

                                                <button
                                                   className='send-button'
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      sendChatRequestAPIcall(loginVal.user_Id, item.userId, index, 2);
                                                   }}
                                                >
                                                   Decline
                                                </button>

                                             </>
                                          )}

                                          {item.type == 2 && item.is_Interestlist == false && (

                                             <>

                                                <button
                                                   className='send-button'
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      sendChatRequestAPIcall(loginVal.user_Id, item.userId, index, 1);
                                                   }}
                                                >
                                                   Accept Chat Interest
                                                </button>
                                                <label>
                                                   Declined
                                                </label>
                                             </>
                                          )} */}


                                       </div>
                                       <br />
                                       <div className='row'>
                                          <div className="col d-flex flex-column flex-md-row justify-content-between gap-2 mt-0">

                                             <label
                                                className="verify-text normal-text p-1"
                                                style={{
                                                   backgroundColor: "hsl(90, 42%, 87%)",
                                                   borderRadius: "6px",
                                                   width: "200px",
                                                   height: "30px"
                                                }}
                                             >
                                                <i className="bi bi-phone pe-1 " style={{ color: "green" }}></i>
                                                <span
                                                   style={{

                                                      fontSize: "13px",
                                                      textDecoration: "none",
                                                      fontWeight: "bold",
                                                      color: item.mobileNumber_Status ? "green" : "red"
                                                   }}
                                                >
                                                   {item.mobileNumber_Status
                                                      ? "Mobile Verified"
                                                      : "Mobile Not Verified"}
                                                </span>
                                             </label>

                                             {item.documentStatus === 0 && (
                                                <label className='verify-text normal-text  p-1 '
                                                   style={{
                                                      backgroundColor: "hsl(90, 42%, 87%)",
                                                      borderRadius: "6px",
                                                      width: "200px",
                                                      height: "30px"
                                                   }}>
                                                   <i className="bi bi-file-earmark-check ps-1 pe-1" style={{ color: "green" }}></i>
                                                   <span
                                                      style={{
                                                         fontSize: "13px",
                                                         fontWeight: "bold",
                                                         textDecoration: "none",
                                                         color: "green"
                                                      }}
                                                   >
                                                      Documents Verified
                                                   </span></label>
                                             )}
                                          </div>
                                       </div>
                                       {/* <p> She is an <b >Assisted Service Member.</b> Message her for{' '}
                                          <b>FREE</b></p> */}


                                    </div>
                                 </div>
                              ))
                           ) : (
                              <div
                                 className="text-center py-5"
                                 style={{ minHeight: "300px" }}
                              >
                                 <i
                                    className="bi bi-search"
                                    style={{ fontSize: "50px", color: "#999" }}
                                 ></i>

                                 <h4 className="mt-3">No Users Found</h4>


                              </div>
                           )}
                        </div>


                        {/* {activeMatchMenu === "your_matches" && users.length > 0 && ( */}
                        {users.length > 0 && (
                           <div className="pagination-modern">

                              <button
                                 className="page-btn"
                                 onClick={() => handlePageChange(1)}
                                 disabled={currentPage === 1}
                              >
                                 ⏮ First
                              </button>

                              <button
                                 className="page-btn"
                                 onClick={() => handlePageChange(currentPage - 1)}
                                 disabled={currentPage === 1}
                              >
                                 ◀ Prev
                              </button>

                              <div className="page-indicator">
                                 Page <span>{currentPage}</span>
                              </div>

                              {hasMore && (
                                 <button
                                    className="page-btn"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                 >
                                    Next ▶
                                 </button>
                              )}

                           </div>
                        )}

                     </div>
                  </div>
               </div >
            </div>
         </div >
         <footer className='bg-dark text-white text-center '>
            <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
         </footer>
      </>
   );
}

export default Viewpage;
